module.exports = __webpack_public_path__ + "static/media/04062021_arrow_down_140px.38691be9.svg";